import { Icon, type IconProps } from "./icon";

/** Opens a choice: the switcher, a select. */
export function ChevronsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M7 8l3-3 3 3M7 12l3 3 3-3" />
    </Icon>
  );
}
